// @ts-nocheck
/**
 * Created by hao.cheng on 2017/4/16.
 */
import React, { useEffect } from 'react';
import { Button, Divider, Form, Input, message } from 'antd';
import { PwaInstaller } from '../widget';
import { useAlita } from 'redux-alita';
import { RouteComponentProps } from 'react-router';
import { FormProps } from 'antd/lib/form';
import umbrella from 'umbrella-storage';
import { GithubOutlined, LockOutlined, UserOutlined } from '@ant-design/icons';
import { useUpdateEffect } from 'ahooks';
import { IAccount, loginAccount } from '../../service/api/account';

const FormItem = Form.Item;
type LoginProps = {
    setAlitaState: (param: any) => void;
    auth: any;
} & RouteComponentProps &
    FormProps;

const Login = (props: LoginProps) => {
    const { history } = props;
    const [auth, setAlita] = useAlita({ auth: {} }, { light: true });

    useEffect(() => {
        setAlita('auth', null);
    }, [setAlita]);

    useUpdateEffect(() => {
        if (auth && auth.uid) {
            // 判断是否登陆
            umbrella.setLocalStorage('user', auth);
            history.push('/');
        }
    }, [history, auth]);

    const handleSubmit = (values: IAccount) => {
        if (!values.username || !values.password) {
            message.error('账号或密码不能为空');
        }
        loginAccount({
            ...values,
        }).then((info: any) => {
            console.log("info:" + JSON.stringify(info));
            if (info.data.success) {
                // 将token设置在localStorage中
                localStorage.setItem('token', info.data.token);
                // 将accountId设置在localStorage中
                localStorage.setItem('accountId', info.data.accountId);
                setAlita({ funcName: info.data.username, stateName: 'auth' });
                message.success("登录成功");
                window.location.replace("#/app/dashboard/index");
            } else {
                message.error(info.data.message);
            }
        });
    };

    return (
        <div className="login" style={{ background: '#f7f8fa' }}>
            <div >
                <img src={"https://csn-images.oss-cn-shenzhen.aliyuncs.com/markdown/20211229235440.png"} style={{ width: '1000px' }}></img>
            </div>
            <div className="login-form" style={{ borderRadius: '5px', boxShadow: '0 2px 20px rgb(159 177 200 / 24%)', width: '398px', height: '444px' }}>
                <div >
                    <h1 >赛亚街舞</h1>
                    <PwaInstaller />
                </div>
                <Form onFinish={handleSubmit} style={{ maxWidth: '398px' }} layout="vertical" hideRequiredMark>
                    <FormItem
                        name="username"
                        label="账号"
                    >
                        <Input
                            placeholder="请输入账号"
                            bordered={true}
                            style={{
                                border: 'none',
                                outline: 'none',
                                width: '95%',
                                boxShadow: 'none'
                            }}
                        />
                    </FormItem>
                    <Divider />
                    <FormItem
                        name="password"
                        label="密码"
                    >
                        <Input
                            type="password"
                            placeholder="请输入密码"
                            bordered={true}
                            style={{
                                border: 'none',
                                outline: 'none',
                                width: '95%',
                                boxShadow: 'none'
                            }}
                        />
                    </FormItem>
                    <Divider />
                    <FormItem>
                        <Button
                            type="primary"
                            htmlType="submit"
                            className="login-form-button"
                            style={{ width: '100%', borderRadius: '5px', height: '50px' }}
                        >
                            登录
                        </Button>
                        <p style={{ display: 'flex', paddingTop: "20px" }}>
                            <span style={{ color: 'rgba(31,31,31,.6)' }}>温馨提示：开通新账号，请联系管理员</span>
                        </p>
                    </FormItem>
                </Form>
            </div>
        </div>
    );
};

export default Login;
